import Step from 'apollo-react/components/Step';
import StepLabel from 'apollo-react/components/StepLabel';
import Stepper from 'apollo-react/components/Stepper';
import React from 'react';

import { useTranslation } from '../custom-hooks/useTranslation';

export const StepProgress = ({ activeStep, steps, hasError }) => {
  const translateString = useTranslation();

  return (
    <div style={{ marginBottom: 20, marginTop: 20 }}>
      <Stepper activeStep={activeStep} alternativeLabel>
        {steps.map((label, index) => (
          <Step key={label}>
            {hasError && activeStep === index ? (
              <StepLabel StepIconComponent={null} error>
                {translateString(label)}
              </StepLabel>
            ) : (
              <StepLabel>{translateString(label)}</StepLabel>
            )}
          </Step>
        ))}
      </Stepper>
    </div>
  );
};
